import React from 'react';
import PortsDropdown from '../PortsDropdown';
import './PortItineraryInput.css';

// Ordered add/remove port rows — one direction of a fixture's itinerary.
//
// A fixture can call at more than one load port and more than one discharge
// port (task card: freight-recap-multi-ports), so each direction is an
// ORDERED list rather than a single box. Every row is the same PortsDropdown
// the single-port field used, so lookup, free-text and validation behaviour
// are unchanged; only the arity is new.
//
// Contract:
//   - ``ports``: ordered array of plain strings (what PortsDropdown emits).
//   - ``onChange(nextArray)``: fired with the whole new ordered array.
//   - An empty list still renders ONE blank row so the field is usable; that
//     blank row is not data — the caller strips empties before saving, and a
//     recap with no ports saves fine (no invented placeholder).
const PortItineraryInput = ({
  ports,
  onChange,
  label = 'port',
  placeholder = 'Enter port',
  className = 'trade-recap-ports-search',
}) => {
  const list = Array.isArray(ports) && ports.length ? ports : [''];

  const emit = (next) => {
    if (typeof onChange === 'function') {
      onChange(next.filter((p) => p !== null && p !== undefined));
    }
  };

  const setAt = (index, value) => {
    const next = [...list];
    next[index] = value;
    emit(next);
  };

  const removeAt = (index) => {
    const next = list.filter((_, i) => i !== index);
    // Removing the last row leaves an empty itinerary, not a phantom entry.
    emit(next);
  };

  return (
    <div className="hms-port-itinerary">
      {list.map((port, index) => (
        // Index keys are correct here: the rows ARE the ordered positions,
        // and the values are free text with no stable id of their own.
        // eslint-disable-next-line react/no-array-index-key
        <div className="hms-port-itinerary__row" key={index}>
          <PortsDropdown
            value={port || ''}
            onChange={(value) => setAt(index, value)}
            className={className}
            placeholder={index === 0 ? placeholder : `${placeholder} ${index + 1}`}
          />
          <button
            type="button"
            className="hms-port-itinerary__remove"
            aria-label={`Remove ${label} ${index + 1}`}
            title={`Remove ${label} ${index + 1}`}
            onClick={() => removeAt(index)}
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        className="hms-port-itinerary__add"
        onClick={() => emit([...list, ''])}
      >
        {`+ Add ${label}`}
      </button>
    </div>
  );
};

export default PortItineraryInput;
